const { REACT_APP_TOKEN } = process.env;

export const API_URL = 'https://zancanaro.duocyber.com';
const authHeader = REACT_APP_TOKEN ? { Authorization: REACT_APP_TOKEN } : {};

export const axiosconfig = {
    headers: authHeader
};

export const axiosconfigwithfiles = {
    headers: { ...authHeader, 'Content-Type': 'multipart/form-data' }
};
export const GOOGLE_SITE_KEY = '6LfF5pYaAAAAAAmCrFH-96GkxesgVMt8SOj4Xyj5';

